// Vérifier si une adresse e-mail est valide
export const isDemoKey = (p_key) => {
    return p_key === "987654321" || p_key === "123456789";
  };